import { PartnerCurrencyButtons } from 'legacy/lut/components/widgets/public/partner360/PartnerCurrencyButtons'
import { PartnerTypeButtons } from 'legacy/lut/components/widgets/public/partner360/PartnerTypeButtons'
import { useCurrencyData } from 'legacy/lut/features/partner360/configuration/hooks/useCurrencyData'

import { useFormField } from 'cng-common/features/form'
import { useActualsTypes } from 'partner360/components/actualsTypeButtons'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { GP_KEY_INITIATIVE_FORM_KEY } from '../configs'

import styles from './GPKIValueTypeAndCurrency.module.scss'

interface IProps {
  initialValueType?: string | null
}

export const GPKIValueTypeAndCurrency = ({ initialValueType }: IProps) => {
  const { currency, localCurrency } = useCurrencyData()
  const { actualsTypes } = useActualsTypes()

  const { value: formCurrency, handleChange: handleCurrencyChange } = useFormField({
    defaultValue: currency,
    formKey: GP_KEY_INITIATIVE_FORM_KEY,
    field: 'currency',
  })

  const { value: formValueType, handleChange: handleValueTypeChange } = useFormField({
    defaultValue: initialValueType || ActualsValueTypes.Ndp,
    formKey: GP_KEY_INITIATIVE_FORM_KEY,
    field: 'valueType',
  })

  return (
    <div className={styles.controls}>
      <PartnerCurrencyButtons
        localCurrency={localCurrency}
        currency={formCurrency}
        setCurrency={handleCurrencyChange}
      />
      <div className={styles.separator} />
      <PartnerTypeButtons
        buttonCurrType={formValueType}
        setButtonCurrType={handleValueTypeChange}
        buttonTypes={actualsTypes}
        translationKey="jbp-partner-actuals-value-type"
      />
    </div>
  )
}
